import { createSlice } from '@reduxjs/toolkit';
import { THeatmapMarkets } from '../types/heatmap.types';

const initialState = {
  isActive: false,
  type: '' as 'price' | 'offers',
  opacity: 0.7,
  primaryMarket: {
    maxPrice: 0,
    maxOffers: 0,
    price: [],
    offers: [],
  },
  secondaryMarket: {
    maxPrice: 0,
    maxOffers: 0,
    price: [],
    offers: [],
  },
};

const heatmapSlice = createSlice({
  name: 'heatmap',
  initialState,
  reducers: {
    updateHeatmapType: (state, action) => {
      return {
        ...state,
        type: action.payload,
      };
    },
    toggleHeatmapState: (state, action) => {
      return {
        ...state,
        isActive: action.payload,
      };
    },
    changeOpacity: (state, action) => {
      return {
        ...state,
        opacity: action.payload,
      };
    },
    updateHeatmapData: (state, action) => {
      return {
        ...state,
        [action.payload.type]: action.payload.data,
      };
    },
    setMaxPrice: (state, action) => {
      return {
        ...state,
        [action.payload.market]: {
          ...state[action.payload.market as THeatmapMarkets],
          maxPrice: action.payload.maxPrice,
        },
      };
    },
    setMaxOffers: (state, action) => {
      return {
        ...state,
        [action.payload.market]: {
          ...state[action.payload.market as THeatmapMarkets],
          maxOffers: action.payload.maxOffers,
        },
      };
    },
  },
});

export const {
  updateHeatmapType,
  toggleHeatmapState,
  changeOpacity,
  updateHeatmapData,
  setMaxOffers,
  setMaxPrice,
} = heatmapSlice.actions;
export default heatmapSlice.reducer;
